<script lang="ts">
	// Formating
	import { format } from 'svelte-i18n';
	//Design system
	import { Text, Input, Select } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar, isValidURL } from 'src/helpers/utilities';
	//Types
	import type { VirtualComponentInterface } from 'src/types/VirtualComponents';

	export let settings: VirtualComponentInterface['config'];
	export let errorURLFalse: boolean;
	export let errorURLTrue: boolean;

	const viewOptions = [
		{
			title: capFirstChar(
				$format('virtual_component_label', {
					default: 'label',
				}),
			),
			value: 'label',
		},
		{
			title: capFirstChar(
				$format('virtual_component_label_toggle', {
					default: 'toggle',
				}),
			),
			value: 'toggle',
		},
		{
			title: capFirstChar(
				$format('virtual_component_label_hidden', {
					default: 'hidden',
				}),
			),
			value: '',
		},
	];

	$: defaultValueOptions = [
		{
			title:
				settings?.meta?.ui?.titles?.[0] ||
				$format('virtual_comp_value_option_false', { default: 'False' }),
			value: false,
			icon: 'fas fa-toggle-off',
		},
		{
			title:
				settings?.meta?.ui?.titles?.[1] ||
				$format('virtual_comp_value_option_true', { default: 'True' }),
			value: true,
			icon: 'fas fa-toggle-on',
		},
	];

	$: errorURLFalse =
		settings?.meta?.ui?.buttonIcons?.[0] !== '' &&
		settings?.meta?.ui?.buttonIcons?.[0] != null &&
		!isValidURL(settings?.meta?.ui.buttonIcons?.[0]);

	$: errorURLTrue =
		settings?.meta?.ui?.buttonIcons?.[1] !== '' &&
		settings?.meta?.ui?.buttonIcons?.[1] != null &&
		!isValidURL(settings?.meta?.ui?.buttonIcons?.[1]);
</script>

<Text styleType="h2" class="mb-s">
	{$format('virtual_component_title_view', {
		default: 'View',
	})}
</Text>
<Select
	aria-label={$format('select_view', { default: 'Select view' })}
	class="width-full mb-m"
	value={viewOptions.find((i) => i.value == settings?.meta?.ui.view) || viewOptions[0]}
	options={viewOptions}
	icon="fas fa-eye"
	on:change={(e) => {
		settings.meta.ui.view = e.detail['value'];
	}}
	id="select-11cknjx"
/>

<Text styleType="h2" class="mb-s">
	{$format('virtual_component_title_when_false', {
		default: 'Title When False',
	})}
</Text>
<Input
	aria-label={$format('input_title_when_false', { default: 'Enter title when false' })}
	size="m"
	class="mb-m"
	icon="fas fa-toggle-off"
	maxlength="255"
	value={settings?.meta?.ui?.titles?.[0] || ''}
	on:input={(e) => {
		const title = e.target['value'];
		if (!settings?.meta?.ui?.titles) settings.meta.ui.titles = ['', ''];
		settings.meta.ui.titles[0] = title;
	}}
	id="input-isuab1r"
/>

<Text styleType="h2" class="mb-s">
	{$format('virtual_component_title_when_true', {
		default: 'Title When True',
	})}
</Text>
<Input
	aria-label={$format('input_title_when_true', { default: 'Enter title when true' })}
	size="m"
	class="mb-m"
	icon="fas fa-toggle-on"
	maxlength="255"
	value={settings?.meta?.ui.titles?.[1] || ''}
	on:input={(e) => {
		const title = e.target['value'];
		if (!settings?.meta?.ui?.titles) settings.meta.ui.titles = ['', ''];
		settings.meta.ui.titles[1] = title;
	}}
	id="input-5zi14a6"
/>

<Text styleType="h2" class="mb-s">
	{$format('virtual_component_title_icon_false', {
		default: 'Icon URL (False)',
	})}
</Text>
<Input
	aria-label={$format('input_icon_url_false', { default: 'Enter icon URL when false' })}
	size="m"
	class="mb-m"
	icon="fas fa-image"
	maxlength="512"
	value={settings?.meta?.ui.buttonIcons?.[0] || ''}
	error={errorURLFalse
		? $format('enter_valid_url', {
				default: 'Invalid URLs: Please enter a valid URL!',
			})
		: ''}
	on:input={(e) => {
		if (!settings?.meta?.ui?.buttonIcons) settings.meta.ui.buttonIcons = ['', ''];
		settings.meta.ui.buttonIcons[0] = e.target['value'];
	}}
	id="input-zpomdvi"
/>

<Text styleType="h2" class="mb-s">
	{$format('virtual_component_title_icon_true', {
		default: 'Icon URL (True)',
	})}
</Text>
<Input
	aria-label={$format('input_icon_url_true', { default: 'Enter icon URL when true' })}
	size="m"
	class="mb-m"
	icon="fas fa-image"
	maxlength="512"
	value={settings?.meta?.ui.buttonIcons?.[1] || ''}
	error={errorURLTrue
		? $format('enter_valid_url', {
				default: 'Invalid URLs: Please enter a valid URL!',
			})
		: ''}
	on:input={(e) => {
		if (!settings?.meta?.ui?.buttonIcons) settings.meta.ui.buttonIcons = ['', ''];
		settings.meta.ui.buttonIcons[1] = e.target['value'];
	}}
	id="input-7wxc9ru"
/>

<Text styleType="h2" class="mb-s">
	{$format('virtual_component_default_value', {
		default: 'Default Value',
	})}
</Text>
<Select
	aria-label={$format('select_default_value', { default: 'Select default value' })}
	class="width-full mb-m"
	value={defaultValueOptions.find((i) => i.value == settings.default_value) || defaultValueOptions[0]}
	options={defaultValueOptions}
	icon={(defaultValueOptions.find((i) => i.value == settings.default_value) || defaultValueOptions[0])
		.icon}
	on:change={(e) => {
		settings.default_value = e.detail['value'];
	}}
	id="select-8iyxm16"
/>
